/* global swal, axios, Dropzone, ClipboardJS, LazyLoad */

const lsKeys = {
  token: 'token',
  chunkSize: 'chunkSize',
  parallelUploads: 'parallelUploads',
  uploadsHistoryOrder: 'uploadsHistoryOrder',
  previewImages: 'previewImages',
  fileLength: 'fileLength',
  uploadAge: 'uploadAge',
  stripTags: 'stripTags'
}

const page = {
  // user token
  token: localStorage[lsKeys.token],

  // configs from api/check
  maintenance: false,
  apiChecked: false,
  private: null,
  enableUserAccounts: null,
  maxSize: null,
  chunkSizeConfig: null,
  temporaryUploadAges: null,
  defaultTemporaryUploadAge: null,
  fileIdentifierLength: null,
  stripTagsConfig: null,

  // store album id that will be used with upload requests
  album: null,

  parallelUploads: null,
  previewImages: null,
  fileLength: null,
  uploadAge: null,
  stripTags: null,

  maxSizeBytes: null,
  urlMaxSize: null,
  urlMaxSizeBytes: null,
  chunkSize: null,

  tabs: [],
  activeTab: null,
  albumSelect: null,
  albumSelectOnChange: null,
  previewTemplate: null,

  dropzone: null,
  clipboardJS: null,
  lazyLoad: null,

  // additional vars for url uploads
  urlsQueue: [],
  activeUrlsQueue: 0,

  // Include BMP for uploads preview only, cause the real images will be used
  // Sharp isn't capable of making their thumbnails for dashboard and album public pages
  imageExts: ['.gif', '.jpeg', '.jpg', '.png', '.svg', '.tif', '.tiff', '.webp', '.bmp'],
  videoExts: ['.avi', '.m2ts', '.m4v', '.mkv', '.mov', '.mp4', '.webm', '.wmv'],

  albumTitleMaxLength: 70,
  albumDescMaxLength: 4000,

  nodeApi: null
}

// Handler for errors during initialization
page.onInitError = error => {
  // Hide these elements
  document.querySelector('#albumDiv').classList.add('is-hidden')
  document.querySelector('#tabs').classList.add('is-hidden')
  document.querySelectorAll('.tab-content').forEach(element => {
    return element.classList.add('is-hidden')
  })

  // Update upload button
  // const uploadButton = document.querySelector('#loginToUpload')
  // uploadButton.innerText = 'An error occurred. Try to reload?'
  // uploadButton.classList.remove('is-loading')
  // uploadButton.classList.remove('is-hidden')

  // uploadButton.addEventListener('click', () => {
  //   window.location.reload()
  // })

  if (!error) return
  if (error.response) page.onAxiosError(error)
  else page.onError(error)
}

// Handler for regular JS errors
page.onError = error => {
  console.error(error)

  // const content = document.createElement('div')
  // content.innerHTML = `
  //   <p><code>${error.toString()}</code></p>
  //   <p>Please check your console for more information.</p>
  // `
  // return swal({
  //   title: 'An error occurred!',
  //   icon: 'error',
  //   content
  // })
}

// Handler for Axios errors
page.onAxiosError = (error, cont) => {
  if (!cont) console.error(error)

  // Better Cloudflare errors
  const cloudflareErrors = {
    520: 'Unknown Error',
    521: 'Web Server Is Down',
    522: 'Connection Timed Out',
    523: 'Origin Is Unreachable',
    524: 'A Timeout Occurred',
    525: 'SSL Handshake Failed',
    526: 'Invalid SSL Certificate',
    527: 'Railgun Error',
    530: 'Origin DNS Error'
  }

  const statusText = cloudflareErrors[error.response.status] || error.response.statusText

  if (!cont) {
    const description = error.response.data && error.response.data.description
      ? error.response.data.description
      : 'There was an error with the request.\nPlease check the console for more information.'
    return swal(`${error.response.status} ${statusText}`, description, 'error')
  } else if (error.response.data && error.response.data.description) {
    return error.response
  } else {
    const description = error.response
      ? `${error.response.status} ${statusText}`
      : error.toString()
    return { data: { success: false, description } }
  }
}

page.checkClientVersion = apiVersion => {
  const self = document.querySelector('#mainScript')
  const match = self.src.match(/\?_=(\d+)$/)
  if (match && match[1] && match[1] !== apiVersion) {
    return swal({
      title: 'Update detected!',
      text: 'Client assets have been updated. Reload to display the latest version?',
      icon: 'info',
      buttons: {
        confirm: {
          text: 'Reload',
          closeModal: false
        }
      }
    }).then(() => {
      window.location.reload()
    })
  }
}

page.checkIfPublic = () => {
  return axios.get('api/check', {
    onDownloadProgress: () => {
      if (typeof render !== 'undefined' && !render.done) render.do();
      if (typeof newsfeed !== 'undefined' && !newsfeed.done) newsfeed.do();
      if (!page.apiChecked) page.apiChecked = true;
    }
  }).then(response => {
    if (response.data.version) {
      page.checkClientVersion(response.data.version);
    }

    page.private = response.data.private;
    page.enableUserAccounts = response.data.enableUserAccounts;
    page.maxSize = parseInt(response.data.maxSize);
    page.maxSizeBytes = page.maxSize * 1e6;
    page.chunkSizeConfig = {
      max: (response.data.chunkSize && parseInt(response.data.chunkSize.max)) || 95,
      default: response.data.chunkSize && parseInt(response.data.chunkSize.default),
    };
    page.temporaryUploadAges = response.data.temporaryUploadAges;
    page.defaultTemporaryUploadAge = response.data.defaultTemporaryUploadAge || null;
    page.fileIdentifierLength = response.data.fileIdentifierLength;
    page.stripTagsConfig = response.data.stripTags;
    page.maintenance = response.data.maintenance; // Store the maintenance flag

    return page.preparePage();
  }).catch(page.onInitError);
};

page.preparePage = () => {
  if (page.token) {
    return page.verifyToken(page.token);
  }
  if (page.maintenance) {
    // Show maintenance message for non-admin users
    return swal("Under maintenance", "Please try again later.", "error");
  }
  if (!page.private) {
    return page.prepareUpload();
  }
};

page.prepareApiUrl = () => {
  // Check if nodeApi is in sessionStorage
  if (sessionStorage.hasOwnProperty("nodeApi")) {
    page.nodeApi = sessionStorage.getItem("api");
    document.dispatchEvent(new CustomEvent('nodeApiSet'));
    return page.prepareUpload();
  } else {
    // Fetch nodeApi using axios
    return axios.get("api/node", { headers: { token: page.token } })
      .then(function (e) {
        if (e.data.success) {
          page.nodeApi = e.data.url;
          sessionStorage.setItem("api", e.data.url);
          document.dispatchEvent(new CustomEvent('nodeApiSet'));
          return page.prepareUpload();
        } else {
          // Handle error
          swal("An error occurred!", e.data.description, "error");
        }
      })
      .catch(page.onInitError);
  }
}

page.getApiUploadUrl = () => {
  return page.nodeApi
}

page.verifyToken = token => {
  return axios.post('api/tokens/verify', { token }).then(response => {
    localStorage[lsKeys.token] = token;
    page.token = token;

    // If maintenance is enabled and the user is not admin/moderator, show an error
    if (
      page.maintenance &&
      !(response.data.permissions.admin || response.data.permissions.moderator)
    ) {
      return swal("Under maintenance", "Please try again later.", "error").then(() => {
        throw new Error("Under maintenance");
      });
    }

    if (Array.isArray(response.data.retentionPeriods)) {
      page.temporaryUploadAges = response.data.retentionPeriods;
      page.defaultTemporaryUploadAge = response.data.defaultRetentionPeriod;
    }

    return page.prepareApiUrl();
  }).catch(error => {
    return swal({
      title: 'An error occurred!',
      text: error.toString(),
      icon: 'error',
    }).then(() => {
      if (error.response && error.response.data && error.response.data.code === 10001) {
        localStorage.removeItem(lsKeys.token);
        window.location.reload();
      } else {
        page.onInitError();
      }
    });
  });
};

page.prepareUpload = () => {
  // I think this fits best here because we need to check for a valid token before we can get the albums
  if (page.token) {
    // Change /auth link to /dashboard
    const authLink = document.querySelector('#linksColumn a[href="auth"]')
    if (authLink) authLink.setAttribute('href', 'dashboard')

    // Display the album selection
    document.querySelector('#containerDiv').classList.remove('is-hidden')
    document.querySelector('#albumDiv').classList.remove('is-hidden')

    page.albumSelect = document.querySelector('#albumSelect')
    page.albumSelectOnChange = () => {
      page.album = parseInt(page.albumSelect.value)
      // Re-generate ShareX config file
      if (typeof page.prepareShareX === 'function') page.prepareShareX()
    }
    page.albumSelect.addEventListener('change', page.albumSelectOnChange)

    // page.fetchNode()
    // Fetch albums
    page.fetchAlbums()
  } else if (page.enableUserAccounts) {
    document.querySelector('#loginLinkText').innerHTML = 'Create an account and keep track of your uploads'
  }

  // Prepare & generate config tab
  page.prepareUploadConfig()

  // Update elements wherever applicable
  document.querySelector('#maxSize > span').innerHTML = page.getPrettyBytes(page.maxSizeBytes)
  document.querySelector('#heroDiv').classList.add('is-hidden')

  // Prepare & generate files upload tab
  page.prepareDropzone()

  // Generate ShareX config file
  if (typeof page.prepareShareX === 'function') page.prepareShareX()

  // Prepare urls upload tab
  const urlMaxSize = document.querySelector('#urlMaxSize')
  if (urlMaxSize) {
    page.urlMaxSize = parseInt(urlMaxSize.innerHTML)
    page.urlMaxSizeBytes = page.urlMaxSize * 1e6
    urlMaxSize.innerHTML = page.getPrettyBytes(page.urlMaxSizeBytes)
  }

  const uploadUrls = document.querySelector('#uploadUrls')
  if (uploadUrls) {
    uploadUrls.addEventListener('click', event => {
      page.addUrlsToQueue()
    })
  }

  // Get all tabs
  const tabsContainer = document.querySelector('#tabs')
  const tabs = tabsContainer.querySelectorAll('li')
  for (let i = 0; i < tabs.length; i++) {
    const id = tabs[i].dataset.id
    const tabContent = document.querySelector(`#${id}`)
    if (!tabContent) continue

    tabs[i].addEventListener('click', () => {
      page.setActiveTab(i)
    })
    page.tabs.push({ tab: tabs[i], content: tabContent })
  }

  // Set first valid tab as the default active tab
  if (page.tabs.length) {
    page.setActiveTab(0)
    tabsContainer.classList.remove('is-hidden')
  }
}

page.setActiveTab = index => {
  for (let i = 0; i < page.tabs.length; i++) {
    if (i === index) {
      page.tabs[i].tab.classList.add('is-active')
      page.tabs[i].content.classList.remove('is-hidden')
      page.activeTab = index
    } else {
      page.tabs[i].tab.classList.remove('is-active')
      page.tabs[i].content.classList.add('is-hidden')
    }
  }
}

page.fetchAlbums = () => {
  return axios.get('api/albums', {
    headers: {
      simple: '1',
      token: page.token
    }
  }).then(response => {
    if (response.data.success === false) {
      return swal('An error occurred!', response.data.description, 'error');
    }

    // Create an option for each album, sorted alphabetically
    if (Array.isArray(response.data.albums) && response.data.albums.length) {
      // Sort albums alphabetically by name
      response.data.albums.sort((a, b) => a.name.localeCompare(b.name));

      for (let i = 0; i < response.data.albums.length; i++) {
        const album = response.data.albums[i];
        const option = document.createElement('option');
        option.value = album.id;
        option.innerHTML = album.name;
        page.albumSelect.appendChild(option);
      }
    }
  }).catch(page.onInitError);
};


page.prepareDropzone = () => {
  // Parse template element
  const previewNode = document.querySelector('#tpl')
  page.previewTemplate = previewNode.innerHTML
  previewNode.parentNode.removeChild(previewNode)

  // Generate files upload tab
  const tabDiv = document.querySelector('#tab-files')
  const maxSizeInt = page.getPrettyBytes(page.maxSizeBytes)
  const div = document.createElement('div')
  div.className = 'control is-expanded'
  div.innerHTML = `
  <div id="dropzone">
    <span class="w-12 h-12 bg-main/10 text-main rounded-full ic-upload-cloud-02 ic-before before:text-2xl grid place-content-center mx-auto group-hover/item:bg-main group-hover/item:text-fore"></span>
    <label for="file" id="maxSize" class="grid auto-rows-max gap-0.5">
        <p><span class="font-semibold text-main">Click to upload</span> or drag &amp; drop files</p>
        <p class="text-xs">Maximum upload size per file is <span class="font-semibold">${maxSizeInt}</span></p>
    </label>
</div>

  `

  tabDiv.querySelector('.dz-container').appendChild(div)

  // const previewsContainer = tabDiv.querySelector('#tab-files .field.uploads')
  const tabUrlsDiv = document.querySelector('#tab-urls')
  const previewsContainer = tabUrlsDiv.querySelector('.field.uploads')

  page.dropzone = new Dropzone(document.body, {
    // url: 'api/upload',
    url: page.getApiUploadUrl(),
    paramName: 'files[]',
    clickable: tabDiv.querySelector('#dropzone'),
    maxFilesize: page.maxSizeBytes / 1024 / 1024, // this option expects MiB
    parallelUploads: page.parallelUploads,
    uploadMultiple: false,
    previewsContainer,
    previewTemplate: page.previewTemplate,
    createImageThumbnails: false,
    autoProcessQueue: true,
    headers: { token: page.token },
    chunking: Boolean(page.chunkSize),
    chunkSize: page.chunkSize * 1e6, // this option expects Bytes
    parallelChunkUploads: false, // for now, enabling this breaks descriptive upload progress
    timeout: 0,

    init() {
      this.on('addedfile', file => {
        // Set active tab to file uploads, if necessary
        if (page.activeTab !== 0) page.setActiveTab(0);
    
        // Add file entry
        tabDiv.querySelector('.uploads').classList.remove('is-hidden');
        document.querySelector('#tab-urls').classList.remove('is-hidden');
    
        // Set file name
        file.previewElement.querySelector('.name').innerHTML = file.name;
        
        // Indicate the file is waiting in queue
        file.previewElement.querySelector('.descriptive-progress').innerHTML = 'Waiting in queue...';
        file.previewElement.querySelector('.descriptive-progress').classList.remove('is-hidden');
        
        // Hide progress bar when the file is waiting in queue
        file.previewElement.querySelector('.percentage-width').style.display = 'none';
        file.previewElement.querySelector('.percentage-text').style.display = 'none';
    
        // Update file name across elements
        file.previewElement.querySelectorAll('.name').forEach(el => {
            el.innerHTML = file.name;
        });
    });
    
    // Update this when the upload starts to show the progress bar and hide the "waiting" text
    this.on('uploadprogress', file => {
        file.previewElement.querySelector('.descriptive-progress').classList.add('is-hiddena');
        file.previewElement.querySelector('.percentage-width').style.display = 'block';
        file.previewElement.querySelector('.percentage-text').style.display = 'block';
    });
    

      this.on('sending', (file, xhr) => {
        // Add timeout listener (hacky method due to lack of built-in timeout handler)
        if (!xhr.ontimeout) {
          xhr.ontimeout = () => {
            const instances = page.dropzone.getUploadingFiles()
              .filter(instance => instance.xhr === xhr)
            page.dropzone._handleUploadError(instances, xhr, 'Connection timed out. Try to reduce upload chunk size.')
          }
        }

        // Attach necessary data for initial upload speed calculation
        if (typeof xhr._uplSpeedCalc === 'undefined') {
          xhr._uplSpeedCalc = {
            lastSent: 0,
            data: [{ timestamp: Date.now(), bytes: 0 }]
          }
        }

        // If not chunked uploads, add extra headers
        if (!file.upload.chunked) {
          if (page.album !== null) xhr.setRequestHeader('albumid', page.album)
          if (page.fileLength !== null) xhr.setRequestHeader('filelength', page.fileLength)
          if (page.uploadAge !== null) xhr.setRequestHeader('age', page.uploadAge)
          if (page.stripTags !== null) xhr.setRequestHeader('striptags', page.stripTags)
        }

        if (!file.upload.chunked) {
          file.previewElement.querySelector('.descriptive-progress').innerHTML = 'Uploading...'
        } else if (file.upload.chunks.length === 1) {
          file.previewElement.querySelector('.descriptive-progress').innerHTML = `Uploading chunk 1/${file.upload.totalChunkCount}...`
        }
      })

      // Update descriptive progress
      this.on('uploadprogress', (file, progress) => {
        // Total bytes will eventually be bigger than file size when chunked
        const total = Math.max(file.size, file.upload.total)
        const percentage = (file.upload.bytesSent / total * 100).toFixed(0)

        const upl = file.upload.chunked
          ? file.upload.chunks[file.upload.chunks.length - 1]
          : file.upload
        const xhr = upl.xhr || file.xhr

        let prefix = 'Uploading...'
        let skipProgress = false
        if (file.upload.chunked) {
          const done = upl.bytesSent === upl.total
          const last = file.upload.chunks.length === file.upload.totalChunkCount
          let chunkIndex = file.upload.chunks.length
          if (done && !last) {
            chunkIndex++
            skipProgress = true
          }
          prefix = `Uploading chunk ${chunkIndex}/${file.upload.totalChunkCount}...`
        }

        // Real-time upload speed calculation
        let prettyBytesPerSec
        if (!skipProgress) {
          const now = Date.now()
          const bytesSent = upl.bytesSent - xhr._uplSpeedCalc.lastSent

          // Push data of current iteration
          xhr._uplSpeedCalc.lastSent = upl.bytesSent
          xhr._uplSpeedCalc.data.push({ timestamp: now, bytes: bytesSent })

          // Wait till at least the 2nd iteration (3 data including initial data)
          const length = xhr._uplSpeedCalc.data.length
          if (length > 2) {
            // Calculate using data from all iterations
            let elapsed = 0
            let bytesPerSec = 0
            let fullSec = false
            let i = length - 1 // Always start with 2nd from last item
            while (i--) {
              // Splice data of unrequired iterations
              if (fullSec) {
                xhr._uplSpeedCalc.data.splice(i, 1)
                continue
              }
              // Sum data
              elapsed = now - xhr._uplSpeedCalc.data[i].timestamp
              if (elapsed > 1000) {
                const excessDuration = elapsed - 1000
                const newerIterationElapsed = now - xhr._uplSpeedCalc.data[i + 1].timestamp
                const duration = elapsed - newerIterationElapsed
                const fragment = (duration - excessDuration) / duration * xhr._uplSpeedCalc.data[i + 1].bytes
                bytesPerSec += fragment
                fullSec = true
              } else {
                bytesPerSec += xhr._uplSpeedCalc.data[i + 1].bytes
              }
            }

            // If not enough data
            if (!fullSec) bytesPerSec = 1000 / elapsed * bytesPerSec

            // Get pretty bytes
            prettyBytesPerSec = page.getPrettyBytes(bytesPerSec)
          }
        }

         file.previewElement.querySelector('.descriptive-progress').innerHTML = `${prefix} ${percentage}%${prettyBytesPerSec ? ` at ${prettyBytesPerSec}/s` : ''}`

        file.previewElement.querySelector('.percentage-text').innerHTML = `${percentage}%`
        file.previewElement.querySelector('.percentage-width').style = `width: ${percentage}%;`
      })

      this.on('success', (file, data) => {
        if (!data) return
        // file.previewElement.querySelector('.descriptive-progress').classList.add('is-hidden')

        if (data.success === false) {
          file.previewElement.querySelector('.error').innerHTML = data.description
          file.previewElement.querySelector('.error').classList.remove('is-hidden')
        }

        if (Array.isArray(data.files) && data.files[0]) {
          page.updateTemplate(file, data.files[0])
        }
      })

      this.on('error', (file, error, xhr) => {
        let err = error
        if (typeof error === 'object' && error.description) {
          err = error.description
        } else if (xhr) {
          // Formatting the Object is necessary since the function expect Axios errors
          err = page.onAxiosError({
            response: {
              status: xhr.status,
              statusText: xhr.statusText
            }
          }, true).data.description
        } else if (error instanceof Error) {
          err = error.toString()
        }

        // Clean up file size errors
        if (/^File is too big/.test(err) || /File too large/.test(err)) {
          err = `File too large (${page.getPrettyBytes(file.size)}).`
        }

        // file.previewElement.querySelector('.descriptive-progress').classList.add('is-hidden')

        file.previewElement.querySelector('.error').innerHTML = err
        file.previewElement.querySelector('.error').classList.remove('is-hidden')

        page.updateTemplateIcon(file.previewElement, 'icon-block')
      })
    },

    chunksUploaded(file, done) {
      file.previewElement.querySelector('.descriptive-progress').innerHTML =
        `Rebuilding ${file.upload.totalChunkCount} chunks...`

      // return axios.post('api/upload/finishchunks', {
      return axios.post(`${page.getApiUploadUrl()}/finishchunks`, {
        // This API supports an array of multiple files
        files: [{
          uuid: file.upload.uuid,
          original: file.name,
          type: file.type,
          albumid: page.album,
          filelength: page.fileLength,
          age: page.uploadAge
        }]
      }, {
        headers: {
          token: page.token,
          // Unlike the options above (e.g. albumid, filelength, etc.),
          // strip tags cannot yet be configured per file with this API
          striptags: page.stripTags
        }
      }).catch(error => page.onAxiosError(error, true)).then(response => {
        // file.previewElement.querySelector('.descriptive-progress').classList.add('is-hidden')

        if (response.data.success === false) {
          file.previewElement.querySelector('.error').innerHTML = response.data.description
          file.previewElement.querySelector('.error').classList.remove('is-hidden')

          page.updateTemplateIcon(file.previewElement, 'icon-block')
        }

        if (response.data.files && response.data.files[0]) {
          page.updateTemplate(file, response.data.files[0])
        }

        return done()
      })
    }
  })
}

page.addUrlsToQueue = () => {
  const urls = document.querySelector('#urls').value
    .split(/\r?\n/)
    .filter(url => {
      return url.trim().length
    })

  if (!urls.length) {
    return swal('An error occurred!', 'You have not entered any URLs.', 'error')
  }

  const tabDiv = document.querySelector('#tab-urls')
  tabDiv.classList.remove('is-hidden')
  tabDiv.querySelector('.uploads').classList.remove('is-hidden')

  for (let i = 0; i < urls.length; i++) {
    const previewTemplate = document.createElement('template')
    previewTemplate.innerHTML = page.previewTemplate.trim()

    const previewElement = previewTemplate.content.firstChild
    previewElement.querySelector('.name').innerHTML = urls[i]
    // previewElement.querySelector('.descriptive-progress').innerHTML = 'Waiting in queue...'

    const previewsContainer = tabDiv.querySelector('.uploads')
    previewsContainer.appendChild(previewElement)

    page.urlsQueue.push({
      url: urls[i],
      previewElement
    })
  }

  page.processUrlsQueue()
  document.querySelector('#urls').value = ''
}

page.processUrlsQueue = () => {
  if (!page.urlsQueue.length) return

  function finishedUrlUpload(file, data) {
    // file.previewElement.querySelector('.descriptive-progress').classList.add('is-hidden')

    if (data.success === false) {
      const match = data.description.match(/ over limit: (\d+)$/)
      if (match && match[1]) {
        data.description = `File exceeded limit of ${page.getPrettyBytes(match[1])}.`
      }

      file.previewElement.querySelector('.error').innerHTML = data.description
      file.previewElement.querySelector('.error').classList.remove('is-hidden')

      page.updateTemplateIcon(file.previewElement, 'icon-block')
    }

    if (Array.isArray(data.files) && data.files[0]) {
      page.updateTemplate(file, data.files[0])
    }

    page.activeUrlsQueue--
    return shiftQueue()
  }

  function initUrlUpload(file) {
    // file.previewElement.querySelector('.descriptive-progress').innerHTML =
    //   'Waiting for server to fetch URL...'

    // return axios.post('api/upload', {
    return axios.post(page.getApiUploadUrl(), {
      urls: [file.url]
    }, {
      headers: {
        token: page.token,
        albumid: page.album,
        age: page.uploadAge,
        filelength: page.fileLength
      }
    }).catch(error => page.onAxiosError(error, true)).then(response => {
      return finishedUrlUpload(file, response.data)
    })
  }

  function shiftQueue() {
    while (page.urlsQueue.length && (page.activeUrlsQueue < page.parallelUploads)) {
      page.activeUrlsQueue++
      initUrlUpload(page.urlsQueue.shift())
    }
  }

  return shiftQueue()
}

page.updateTemplateIcon = (templateElement, iconClass) => {
  const iconElement = templateElement.querySelector('.icon')
  if (!iconElement) return

  iconElement.classList.add(iconClass)
  iconElement.classList.remove('is-hidden')
}

page.updateTemplate = (file, response) => {
  if (!response.url) return

  file.previewElement.querySelector('.w-uploadprogress').classList.add('is-hidden')
  file.previewElement.querySelector('.w-success').classList.remove('is-hidden')

  const a = file.previewElement.querySelector('.link')
  const clipboard = file.previewElement.querySelector('.clipboard-js')
  a.href = clipboard.dataset.clipboardText = response.url

  // link.classList.remove('is-hidden')
  clipboard.parentElement.classList.remove('is-hidden')

  const exec = /.[\w]+$/.exec(response.url)
  const extname = exec && exec[0]
    ? exec[0].toLowerCase()
    : null

  if (page.imageExts.includes(extname)) {
    if (page.previewImages) {
      const img = file.previewElement.querySelector('img')
      img.setAttribute('alt', response.name || '')
      img.dataset.src = response.url
      img.classList.remove('is-hidden')
      img.onerror = event => {
        // Hide image elements that fail to load
        // Consequently include WEBP in browsers that do not have WEBP support (e.g. IE)
        event.currentTarget.classList.add('is-hidden')
        page.updateTemplateIcon(file.previewElement, 'icon-picture')
      }
      page.lazyLoad.update(file.previewElement.querySelectorAll('img'))
    } else {
      page.updateTemplateIcon(file.previewElement, 'icon-picture')
    }
  } else if (page.videoExts.includes(extname)) {
    page.updateTemplateIcon(file.previewElement, 'icon-video')
  } else {
    page.updateTemplateIcon(file.previewElement, 'icon-doc-inv')
  }

  if (response.expirydate) {
    const expiryDate = file.previewElement.querySelector('.expiry-date')
    expiryDate.dataset.timestamp = response.expirydate
    expiryDate.innerHTML = `EXP: ${page.getPrettyDate(new Date(response.expirydate * 1000))}`
    expiryDate.classList.remove('is-hidden')
  }
}

page.createAlbum = () => {
  const div = document.createElement('div')
  div.innerHTML = `
    <div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-8-xxx sm:p-4-xx sm:place-items-center hidden [&amp;.show]:grid show">
      <div class="bg-mute p-2 w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-md sm:p-4 text-left">
        <div class="grid auto-rows-max gap-4 relative">
          <span class="ic-folder-plus w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span>
          <div class="text-2xl font-bold text-subs font-cabinet">Create new album</div>
        </div>
        <div class="grid auto-rows-max gap-4">
          <div class="grid auto-rows-max gap-1">
            <label class="font-semibold text-subs" for="swalName">Name</label>
            <input class="bg-body sm:text-sm" type="text" id="swalName" placeholder="Name" maxlength="${page.albumTitleMaxLength}">
            <p class="text-xs mt-1">Max length is ${page.albumTitleMaxLength} characters.</p>
          </div>
          <div class="grid auto-rows-max gap-1">
            <label class="font-semibold text-subs" for="description">Description</label>
            <textarea class="bg-body" id="swalDescription" cols="30" rows="10" placeholder="Description" maxlength="${page.albumDescMaxLength}"></textarea>
            <p class="text-xs mt-1">Max length is ${page.albumDescMaxLength} characters.</p>
          </div>
          <div>
            <label class="inline-flex items-center gap-2 py-1">
              <input id="swalDownload" class="bg-body p-0 shrink-0" type="checkbox" checked>
              <span class="font-semibold text-subs">Enable download</span>
            </label>
          </div>
          <div>
            <label class="inline-flex items-center gap-2 py-1">
              <input id="swalPublic" class="bg-body p-0 shrink-0" type="checkbox" checked>
              <span class="font-semibold text-subs">Enable public link</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    `

  swal({
    title: '',
    icon: '',
    content: div,
    className: 'swal-edit-form',
    buttons: {
      cancel: {
        text: 'Cancel',
        className: "btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last",
        visible: true,
        closeModal: true,
      },
      confirm: {
        text: 'Create',
        className: "btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full",
        closeModal: true
      }
    }
  }).then(value => {
    if (!value) return

    const name = document.querySelector('#swalName').value.trim()
    axios.post('api/albums', {
      name,
      description: document.querySelector('#swalDescription').value.trim(),
      download: document.querySelector('#swalDownload').checked,
      public: document.querySelector('#swalPublic').checked
    }, {
      headers: {
        token: page.token
      }
    }).then(response => {
      if (response.data.success === false) {
        return swal('An error occurred!', response.data.description, 'error')
      }

      const option = document.createElement('option')
      page.albumSelect.appendChild(option)
      option.value = response.data.id
      option.innerHTML = name
      option.selected = true
      page.albumSelectOnChange()

      // swal('Woohoo!', 'Album was created successfully.', 'success')
      swal({
        title: 'Woohoo!',
        text: 'Album was created successfully.',
        icon: 'info',
        className: 'swal-general',
        buttons: {
          cancel: false,
          confirm: {
            text: 'OK',
            className: "btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full",
            closeModal: true
          }
        },
      })
    }).catch(page.onError)
  })
}

page.prepareUploadConfig = () => {
  // This object should only be used to set fallback values for page[key]
  // (essentially for page[key] properties that explicitly need to be set as something)
  // As for default values in the Config tab (which will not set page[key]),
  // check out number.default property of each config
  const fallback = {
    chunkSize: page.chunkSizeConfig.default,
    parallelUploads: 2
  }

  const temporaryUploadAges = Array.isArray(page.temporaryUploadAges) &&
    page.temporaryUploadAges.length
  const fileIdentifierLength = page.fileIdentifierLength &&
    typeof page.fileIdentifierLength.min === 'number' &&
    typeof page.fileIdentifierLength.max === 'number'

  const config = {
    siBytes: {
      label: 'File size display',
      select: [
        { value: 'default', text: '1000 B = 1 kB = 1 Kilobyte' },
        { value: '0', text: '1024 B = 1 KiB = 1 Kibibyte' }
      ],
      help: 'This will be used in our homepage, dashboard, and album public pages.',
      valueHandler() { } // Do nothing
    },
    ampmTime: {
      label: 'Show AM/PM on date',
      select: [
        { value: 'default', text: 'No' },
        { value: '1', text: 'Yes' }
      ],
      help: 'This will be used in our homepage and dashboard.',
      valueHandler() { } // Do nothing
    },
    fileLength: {
      display: fileIdentifierLength,
      label: 'File identifier length',
      number: fileIdentifierLength
        ? {
          min: page.fileIdentifierLength.min,
          max: page.fileIdentifierLength.max,
          default: page.fileIdentifierLength.default,
          round: true
        }
        : undefined,
      help: true, // true means auto-generated, for number-based configs only
      disabled: fileIdentifierLength && page.fileIdentifierLength.force
    },
    uploadAge: {
      display: temporaryUploadAges,
      label: 'Upload age',
      select: [],
      help: 'Whether to automatically delete your uploads after a certain amount of time.'
    },
    stripTags: {
      display: page.stripTagsConfig,
      label: 'Strip tags',
      select: page.stripTagsConfig
        ? [
          { value: page.stripTagsConfig.default ? 'default' : '1', text: 'Yes' },
          { value: page.stripTagsConfig.default ? '0' : 'default', text: 'No' }
        ]
        : null,
      help: `Whether to strip tags (e.g. EXIF) from your uploads.<br>
        This only applies to regular image${page.stripTagsConfig && page.stripTagsConfig.video ? ' and video' : ''} uploads (i.e. not URL uploads).`,
      disabled: page.stripTagsConfig && page.stripTagsConfig.force
    },
    chunkSize: {
      display: Boolean(page.chunkSizeConfig.default),
      label: 'Upload chunk size (MB)',
      number: {
        min: 1,
        max: page.chunkSizeConfig.max,
        default: fallback.chunkSize,
        suffix: ' MB',
        round: true
      },
      help: true
    },
    parallelUploads: {
      label: 'Parallel uploads',
      number: {
        min: 1,
        max: 2,
        default: fallback.parallelUploads,
        round: true
      },
      help: true
    },
    uploadsHistoryOrder: {
      label: 'Uploads history order',
      select: [
        { value: 'default', text: 'Older files on top' },
        { value: '0', text: 'Newer files on top' }
      ],
      help: `"Newer files on top" will use a CSS technique, which unfortunately come with <a class="font-semibold text-main hover:underline" href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction#Accessibility_concerns" target="_blank" rel="noopener">some undesirable side effects</a>.<br><br>
        This also affects text selection, such as when trying to select text from top to bottom will result in them being selected from bottom to top instead, and vice versa.`,
      valueHandler(value) {
        if (value === '0') {
          const uploadFields = document.querySelectorAll('.tab-content > .uploads')
          for (let i = 0; i < uploadFields.length; i++) {
            uploadFields[i].classList.add('is-reversed')
          }
        }
      }
    },
    previewImages: {
      label: 'Load images for preview',
      select: [
        { value: 'default', text: 'Yes' },
        { value: '0', text: 'No' }
      ],
      help: 'By default, uploaded images will be loaded as their previews.',
      valueHandler(value) {
        page.previewImages = value !== '0'
      }
    }
  }

  if (temporaryUploadAges) {
    const _default = page.defaultTemporaryUploadAge === null
      ? page.temporaryUploadAges[0]
      : page.defaultTemporaryUploadAge
    const stored = parseFloat(localStorage[lsKeys.uploadAge])
    for (let i = 0; i < page.temporaryUploadAges.length; i++) {
      const age = page.temporaryUploadAges[i]
      config.uploadAge.select.push({
        value: age === _default ? 'default' : String(age),
        text: page.getPrettyUploadAge(age)
      })
      if (age === stored) {
        config.uploadAge.value = stored
      }
    }
  }

  if (fileIdentifierLength) {
    const stored = parseInt(localStorage[lsKeys.fileLength])
    if (!page.fileIdentifierLength.force &&
      !isNaN(stored) &&
      stored >= page.fileIdentifierLength.min &&
      stored <= page.fileIdentifierLength.max) {
      config.fileLength.value = stored
    }
  }

  const tabContent = document.querySelector('#tab-config')
  const form = document.createElement('form')
  form.addEventListener('submit', event => event.preventDefault())

  const configKeys = Object.keys(config)
  for (let i = 0; i < configKeys.length; i++) {
    const key = configKeys[i]
    const conf = config[key]

    // Skip only if display attribute is explicitly set to false
    if (conf.display === false) continue

    const field = document.createElement('div')
    // field.className = "field";
    field.className = "grid auto-rows-max gap-1 pb-4 mb-4 last:mb-0 border-b border-line px-4 sm:px-8";

    let value
    if (!conf.disabled) {
      if (typeof conf.value !== 'undefined') {
        value = conf.value
      } else if (typeof conf.number !== 'undefined') {
        const parsed = parseInt(localStorage[lsKeys[key]])
        if (!isNaN(parsed) && parsed <= conf.number.max && parsed >= conf.number.min) {
          value = parsed
        }
      } else {
        const stored = localStorage[lsKeys[key]]
        if (Array.isArray(conf.select)) {
          value = conf.select.find(sel => sel.value === stored)
            ? stored
            : undefined
        } else {
          value = stored
        }
      }

      // If valueHandler function exists, defer to the function,
      // otherwise pass value to global page object
      if (typeof conf.valueHandler === 'function') {
        conf.valueHandler(value)
      } else if (typeof value !== 'undefined') {
        page[key] = value
      } else if (typeof fallback[key] !== 'undefined') {
        page[key] = fallback[key]
      }
    }

    let control
    if (Array.isArray(conf.select)) {
      control = document.createElement('div')
      control.className = 'select is-fullwidth'

      const opts = []
      for (let j = 0; j < conf.select.length; j++) {
        const opt = conf.select[j]
        const selected = (value && (opt.value === String(value))) ||
          (typeof value === 'undefined' && opt.value === 'default')
        opts.push(`
          <option value="${opt.value}"${selected ? ' selected' : ''}>
            ${opt.text}${opt.value === 'default' ? ' (default)' : ''}
          </option>
        `)
      }

      control.innerHTML = `
        <select id="${key}" class="bg-body text-text sm:text-sm">
          ${opts.join('\n')}
        </select>
      `
    } else if (conf.number) {
      control = document.createElement('input')
      control.id = control.name = key
      control.className = 'input is-fullwidth bg-body text-text sm:text-sm'
      control.type = 'number'

      if (typeof conf.number.min !== 'undefined') control.min = conf.number.min
      if (typeof conf.number.max !== 'undefined') control.max = conf.number.max
      if (typeof value === 'number') control.value = value
      else if (typeof conf.number.default !== 'undefined') control.value = conf.number.default
    }

    let help
    if (conf.disabled) {
      if (Array.isArray(conf.select)) {
        control.querySelector('select').disabled = conf.disabled
      } else {
        control.disabled = conf.disabled
      }
      help = 'This option is currently not configurable.'
    } else if (typeof conf.help === 'string') {
      help = conf.help
    } else if (conf.help === true && typeof conf.number !== 'undefined') {
      const tmp = []

      if (typeof conf.number.default !== 'undefined') {
        tmp.push(`Default is ${conf.number.default}${conf.number.suffix || ''}.`)
      }
      if (typeof conf.number.min !== 'undefined') {
        tmp.push(`Min is ${conf.number.min}${conf.number.suffix || ''}.`)
      }
      if (typeof conf.number.max !== 'undefined') {
        tmp.push(`Max is ${conf.number.max}${conf.number.suffix || ''}.`)
      }

      help = tmp.join(' ')
    }

    field.innerHTML = `
      <label class="font-semibold text-subs">${conf.label}</label>
      <div class="control"></div>
      ${help ? `<p class="help text-xs mt-1 mb-3">${help}</p>` : ''}
    `
    field.querySelector('div.control').appendChild(control)

    form.appendChild(field)
  }

  const submit = document.createElement('div')
  submit.className = 'grid auto-rows-max gap-1 pb-4 mb-4 last:mb-0 border-line px-4 sm:px-8'
  submit.innerHTML = `
    <button id="saveConfig" class="btn btn-lg btn-main ic-lock-01 ic-before font-semibold w-full rounded-lg before:text-xl" type="submit">Save &amp; reload</button>
    <div class="bg-info/5 border border-info/10 rounded-md p-4 mt-4 ic-info-circle ic-before before:text-lg before:text-info gap-2 flex">
      <div class="flex-1 text-xs">
        <p><strong class="block">This configuration will only be used in this browser.</strong>
        After reloading the page, some of them will also be applied to the ShareX config that you can download by clicking on the ShareX icon below.</p>
      </div>
    </div>
  `

  form.appendChild(submit)
  form.querySelector('#saveConfig').addEventListener('click', () => {
    if (!form.checkValidity()) return

    const keys = Object.keys(config)
      .filter(key => config[key].display !== false && config[key].disabled !== true)
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]

      let value
      if (typeof config[key].select !== 'undefined') {
        if (form.elements[key].value !== 'default') {
          value = form.elements[key].value
        }
      } else if (typeof config[key].number !== 'undefined') {
        const parsed = parseInt(form.elements[key].value)
        if (!isNaN(parsed) && parsed !== config[key].number.default) {
          value = Math.min(Math.max(parsed, config[key].number.min), config[key].number.max)
        }
      }

      if (typeof value !== 'undefined') localStorage[lsKeys[key]] = value
      else localStorage.removeItem(lsKeys[key])
    }

    const div = document.createElement('div')
    div.innerHTML = `
      <div class="bg-back/80-xxx fixed-xxx inset-0 w-full h-full-xxx z-50 place-items-end pt-12 sm:p-12-xxx sm:place-items-center hidden [&.show]:grid show">
        <div class="bg-mute p-4 w-full-xxx rounded-t-xl max-h-full-xxx grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-md sm:p-8-xxx">
          <div class="grid auto-rows-max gap-6 p-6-xxx">
            <div class="ic-check ic-before before:text-5xl w-24 h-24 rounded-full bg-wins/10 text-wins grid place-content-center mx-auto"></div>
            <div class="grid auto-rows-max gap-2 text-center">
              <div class="font-cabinet text-3xl font-bold text-lead">Woohoo!</div>
              <p class="text-base text-subs">Configuration saved into this browser.</p>
              <!--<p class="mt-6"><button class="btn btn-main font-semibold btn-lg px-6 rounded-lg" type="button">Continue</button></p>-->
            </div>
          </div>
        </div>
      </div>
    `

    swal({
      // title: "Woohoo!",
      className: "swal-success-container",
      // text: "Configuration saved into this browser.",
      content: div,
      // icon: "success",
      buttons: {
        confim: {
          text: "Continue",
          className: "btn btn-main font-semibold btn-lg px-6 rounded-lg",
          visible: true,
          closeModal: true,
        }
      }
    }).then(() => {
      window.location.reload()
    })
  })

  tabContent.appendChild(form)
}

page.getPrettyUploadAge = hours => {
  if (hours === 0) {
    return 'Permanent'
  } else if (hours < 1) {
    const minutes = hours * 60
    return `${minutes} minute${minutes === 1 ? '' : 's'}`
  } else if (hours >= 24) {
    const days = hours / 24
    return `${days} day${days === 1 ? '' : 's'}`
  } else {
    return `${hours} hour${hours === 1 ? '' : 's'}`
  }
}

page.copyAllLinks = () => {
  const links = document.querySelectorAll('a.link')
  let allLinks = []

  links.forEach(link => {
    allLinks.push(link.href)
  });

  // Copy all links to the clipboard
  const textArea = document.createElement('textarea')
  textArea.value = allLinks.join('\n')
  document.body.appendChild(textArea)
  textArea.select()
  document.execCommand('copy')
  textArea.remove()

  return swal({
    title: '',
    text: 'The links has been copied to clipboard.',
    icon: 'info',
    className: 'swal-general',
    buttons: false,
    timer: 1500
  })
}

// Handle image paste event
window.addEventListener('paste', event => {
  const items = (event.clipboardData || event.originalEvent.clipboardData).items
  const index = Object.keys(items)
  for (let i = 0; i < index.length; i++) {
    const item = items[index[i]]
    if (item.kind === 'file') {
      const blob = item.getAsFile()
      /* eslint-disable-next-line compat/compat */
      const file = new File([blob], `pasted-image.${blob.type.match(/(?:[^/]*\/)([^;]*)/)[1]}`, {
        type: blob.type
      })
      page.dropzone.addFile(file)
    }
  }
})

window.addEventListener('DOMContentLoaded', () => {
  if (window.cookieconsent) {
    window.cookieconsent.initialise({
      cookie: {
        name: 'cookieconsent_status',
        path: window.location.pathname,
        expiryDays: 730,
        secure: window.location.protocol === 'https:'
      },
      palette: {
        popup: {
          background: '#282828',
          text: '#eff0f1'
        },
        button: {
          background: '#209cee',
          text: '#ffffff'
        }
      },
      theme: 'classic',
      position: 'bottom-left',
      content: {
        message: 'We use cookies to offer you a better browsing experience and to analyze our traffic. You consent to our cookies if you continue to use this website.',
        dismiss: 'Got it!',
        link: 'Details in our Cookie Policy',
        href: 'cookiepolicy'
      }
    })
  }

  page.checkIfPublic()

  page.clipboardJS = new ClipboardJS('.clipboard-js')

  page.clipboardJS.on('success', () => {
    return swal({
      title: '',
      text: 'The link has been copied to clipboard.',
      icon: 'info',
      className: 'swal-general',
      buttons: false,
      timer: 1500
    })
  })

  page.clipboardJS.on('error', page.onError)

  page.lazyLoad = new LazyLoad({
    elements_selector: '.field.uploads img'
  })

  document.querySelector('#createAlbum').addEventListener('click', () => {
    page.createAlbum()
  })

  document.querySelector('#copyAllLinks').addEventListener('click', () => {
    page.copyAllLinks()
  })
})


